module.exports={
    "Uplive注册验证": "التحقق من تسجل الدخول فى Uplive",
    "两次输入的密码必须一致": "يجب تطابق كلمة المرور",
    "取消": "إلغاء",
    "如验证出现问题，请点击": "إذا واجهت أي مشكلة أثناء التحقق، برجاء النقر هنا",
    "如验证出现问题，请联系orcalivecs@asiainnovations.com": "إذا كان هناك أية مشكلة في رمز التحقق يُرجى التواصل مع خدمة العملاء من خلال: orcalivecs@asiainnovations.com",
    "如验证出现问题，请联系upcs@asiainnovations.com": "إذا كان هناك أية مشكلة في رمز التحقق يُرجى التواصل مع خدمة العملاء من خلال: upcs@asiainnovations.com",
    "密码修改成功": "نجاح تغيير كلمة المرور",
    "密码格式错误": "خطأ في إدخال كلمة المرور",
    "密码由6-20位由数字和字母组成": "كلمة المرور يجب أن تحتوي على من 6-20 من الأرقام والحروف",
    "恭喜您密码重置成功": "تهانينا! لقد تم إعادة تعيين كلمة المرور بنجاح",
    "恭喜您已成功激活帐户": "تهانينا! لقد تم تفعيل حسابك بنجاح",
    "恭喜您已成功激活账户，赶快返回Uplive中与全球潮人互动吧": "تهانينا! لقد نجحت فى تفعيل الحساب، عُد بسرعة إلى Uplive، والتفاعل مع الناس حول العالم",
    "此链接30分钟内有效，超时请返回应用重新发送": "هذا الرابط فعّال لمدة 30 دقيقة، يُرجى العودة لإعادة إرساله عند انتهاء المُدة",
    "知道了": "موافق",
    "确认修改": "تأكيد التغيير",
    "确认验证": "تأكيد التحقق",
    "网络连接有误, 请稍后再试": "خطأ في الإتصال بالشبكة، يُرجى المحاولة مرة أخرى في وقت لاحق",
    "联系客服": "التواصل مع خدمة العملاء",
    "请再次输入密码": "يُرجى تأكيد إدخال كلمة المرور",
    "请输入正确的验证码": "يُرجى إدخال كود التحقق الصحيح",
    "请返回UpVoice中重新进行邮箱验证": "برجاء العودة إلى UpVoice للبث المباشر، وقُم بإعادة التحقق من إجراءات البريد الإليكتروني",
    "请返回Up直播中重新进行邮箱验证": "برجاء العودة إلى Uplive للبث المباشر، وقُم بإعادة التحقق من إجراءات البريد الإليكتروني",
    "请重新设定登录密码": "يُرجى إعادة تعيين كلمة المرور",
    "请重新设置密码": "يُرجى إعادة تعيين كلمة المرور",
    "赶快返回UpVoice中与全球潮人互动吧": "قُم بالعودة إلى UpVoice للبث المباشر سريعًا حتى تتفاعل مع جميع أنحاء العالم!",
    "赶快返回Up直播中与全球潮人互动吧！": "قُم بالعودة إلى Uplive للبث المباشر سريعًا حتى تتفاعل مع جميع أنحاء العالم!",
    "输入图片中的验证码": "أدخل كود التحقق للصورة",
    "重置密码失败": "فشل في إعادة تعيين كلمة المرور",
    "验证失败": "فشل التحقق",
    "验证失败，请返回Uplive中重新进行邮箱验证": "فشل التحقق، برجاء العودة إلى Uplive لإعادة التحقق من البريد الإلكترونى",
    "验证成功": "تم التحقق بنجاح"
};


// WEBPACK FOOTER //
// ./js/lang/areg.js